/**
 * 86. Report Builder — not available yet (REP-BUILDERS, D661).
 *
 * No route runs a report: `ReportDefinition` is `{name, module, dataset,
 * config}` and nothing interprets `dataset` or `config`. The page listed
 * saved definitions under columns the API never sends (owner, format,
 * schedule, last run, status) and offered a "New report" with no handler.
 * It now says it is not available, and names the slice that brings saved
 * reports on datasets (CF-12, docs/design/configurability.md §9.2).
 */
import { NotAvailablePage } from "@/components/NotAvailable";
import { useTranslation } from "@/lib/i18n";

export function ReportBuilderPage() {
  const { t } = useTranslation();
  return (
    <NotAvailablePage
      title={t("nav.reportBuilder")}
      message={t("notAvailable.reportBuilder")}
      reason="afterLaunch"
      slice="CF-12"
    />
  );
}
